import React, { Component, Fragment } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { requery } from "../../../actions/updateHelp";
import ReactDatatable from '@ashvin27/react-datatable';
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Link} from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import Slider from "react-slick";
import * as myConstList from '../../../BaseUrl';
import moment from 'moment';
import axios from "axios";
const config = {
    headers: {
        Authorization: 'Bearer '+`${localStorage.getItem("jwtToken")}`,
    },
};
const callBackBaseUrl = myConstList.callBackBaseUrl;
const baseUrl = myConstList.baseUrl;
class PastContest extends React.Component {

    constructor(props) {
        super(props);
        const { user } = this.props.auth;
        this.state = {
            records:[],
            id: this.props.id,
            description: '',
            message: '',
            username:user.name,
            showResults: false,
            showTeaxtArea: true,
            urltemp:"",
            contestCreated:"",
            errors: {},
        };
        console.log("PathName===",window.location.pathname);
        let pathNameComplete = window.location.pathname;
        let arrSplitText = pathNameComplete.split("/");
        let contestCreatedScree = arrSplitText[1];
        // reactData Table
        console.log("contestcreated==",this.state.contestCreated );
        if(contestCreatedScree ==="contest"){
            this.columns = [
                {
                    key: "contestName",
                    text: "Contest Name",
                    classNameName: "contestName",
                    align: "left",
                    sortable: true,
                },
                {
                    key: "exchange_type",
                    text: "Exchange Type",
                    classNameName: "contestName",
                    align: "left",
                    sortable: true,
                },
                {
                    key: "winningAmount",
                    text: "Prize pool",
                    classNameName: "winningAmount",
                    align: "left",
                    sortable: true,
                },
                {
                    key: "numOfParticipation",
                    text: "Participants",
                    classNameName: "numOfParticipation",
                    align: "left",
                    sortable: true,
                    cell: record => {
                        return (
                            <Fragment>
                              {record.numOfParticipation+"/"+record.max_particepate}
                            </Fragment>
                        );
                    }
                },{
                    key: "startDate",
                    text: "Timing",
                    classNameName: "startDate",
                    align: "left",
                    sortable: true,
                    cell: record => {
                        return (
                            <Fragment>
                                {moment.utc(record.startDate).format("YYYY-MM-DD HH:mm")+" - "+moment.utc(record.endDate).format("YYYY-MM-DD HH:mm")}
                              {/* {record.startDate+"("+record.startTime+") - "+record.endDate+"("+record.endTime+")"} */}
                            </Fragment>
                        );
                    }
                }
                ,{
                    key: "_id",
                    text: "Action",
                    classNameName: "action",
                    align: "left",
                    sortable: true,
                    cell: record => {
                        return (
                            <Fragment>
                              <Link className="btn btn_man" to={"/trading-contest/" + record.contest_id+this.state.urltemp} onClick={() => this.tabPastViewDetailClick(record.contest_id,'Past')}><span>
                                        View Details</span></Link>
                            </Fragment>
                        );
                    }
                }
            ];
        }else{
            this.columns = [
                {
                    key: "contestName",
                    text: "Contest Name",
                    classNameName: "contestName",
                    align: "left",
                    sortable: true,
                },
                {
                    key: "winningAmount",
                    text: "Prize pool",
                    classNameName: "winningAmount",
                    align: "left",
                    sortable: true,
                },
                {
                    key: "numOfParticipation",
                    text: "Participants",
                    classNameName: "numOfParticipation",
                    align: "left",
                    sortable: true,
                    cell: record => {
                        return (
                            <Fragment>
                              {record.numOfParticipation+"/"+record.max_particepate}
                            </Fragment>
                        );
                    }
                },{
                    key: "startDate",
                    text: "Timing",
                    classNameName: "startDate",
                    align: "left",
                    sortable: true,
                    cell: record => {
                        return (
                            <Fragment>
                                {moment.utc(record.startDate).format("YYYY-MM-DD HH:mm")+" - "+moment.utc(record.endDate).format("YYYY-MM-DD HH:mm")}
                              {/* {record.startDate+"("+record.startTime+") - "+record.endDate+"("+record.endTime+")"} */}
                            </Fragment>
                        );
                    }
                }
                ,{
                    key: "_id",
                    text: "Action",
                    classNameName: "action",
                    align: "left",
                    sortable: true,
                    cell: record => {
                        return (
                            <Fragment>
                              <Link className="btn btn_man" to={"/trading-contest/" + record.contest_id+this.state.urltemp} onClick={() => this.tabPastViewDetailClick(record.contest_id,'Past')}><span>
                                        View Details</span></Link>
                            </Fragment>
                        );
                    }
                }
            ];
        }
        
    }
    componentDidMount() {
        if(localStorage.getItem("source") !== "" && localStorage.getItem("theme") !== ""){
            const urltemp = "?source="+localStorage.getItem("source")+"&theme="+localStorage.getItem("theme");
            this.setState({urltemp:urltemp});
        }
        if (!this.props.auth.isAuthenticated) {                
            window.location = callBackBaseUrl+"?callBack="+window.location.origin;
        }
    };
    componentWillReceiveProps(nextProps) {
        // console.log("nextProps.recordpast====",nextProps.record);
        if (nextProps.record) {
            //if(nextProps.record.length !== this.state.records.length ){
                this.setState({
                    records: nextProps.record,
                    bonus:nextProps.bonus,
                    contestCreated:nextProps.contestCreated
                });
            //}
        }
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
        if (nextProps.auth !== undefined
            && nextProps.auth.user !== undefined
            && nextProps.auth.user.data !== undefined
            && nextProps.auth.user.data.message !== undefined
            && nextProps.auth.user.data.success) {

            this.setState({
                message: nextProps.auth.user.data.message
            });
        }
    }
    getNodesToRemoveFromElement = (stringContent) => {
 
        var div = document.createElement("div");
        div.innerHTML = stringContent;
        var text = div.textContent || div.innerText || "";
        return text;
    };
    onChange = e => {
        if (e.target.id === 'user-update-subject') {
            this.setState({ subject: e.target.value });
        }

    };
    handleCommentChange = (event, editor) => {

        var data = editor.getData();
        if (data) {
            this.setState({ description: data });
        }
        this.setState({
            showResults: this.state.name === null ? false : true
        })
    };

    onUserUpdate = e => {
        const { user } = this.props.auth;
        e.preventDefault();
        const newUser = {
            _id: this.props.match.params.id,
             user_id: user.id,
             description: this.state.description


        };
        this.props.requery(newUser);
    };
   
    tabPastViewDetailClick(contestId,tabType){
        const { user } = this.props.auth;
        axios        
        .post(baseUrl + "api/contestByID-data", { id: contestId}, config)
        .then(res => {
            // console.log("res.data.data",res.data.data.item);
            if(res.data.data.item){
                const data = res.data.data.item;        
                var endDate = data.endDate+' '+data.endTime;
                endDate = endDate.toISOString();   
                var startDate = data.startDate+' '+data.startTime;
                startDate = startDate.toISOString();   
                window.webengage.track('Virtual Trading_Contest Details Viewed', {
                    'Category Name':tabType,
                    'Contest Name':data.contestName,
                    'Current Status':'Past',
                    'Ends in':new Date(endDate),
                    'Number of participants':data.numOfParticipation,
                    'Prize pool':data.winningAmount,
                    'Started At':new Date(startDate)
                });
            }
        })       
    }

    render() {
        var settings = {
            initialSlide: 0,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 3500,
            dots: true,
            arrows: false,
            pauseOnHover: true,
            pauseOnFocus: true,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    adaptiveHeight: true,
                  },
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow:1,
                    slidesToScroll: 1,
                  },
                },
            ],
            
        };
        const { errors } = this.state;
        const { user } = this.props.auth;
        return (
            <div className="crypt-market-status2 mt-4 p-2 p-sm-3">
					<div className=" table-striped mb-0">
					<div className="ccrool_table">
					 
					<ReactDatatable
                    records={this.state.records}
                    columns={this.columns}
                    
                />

					 </div>
	
					 </div>
					 </div>
           
)
    }
}

PastContest.propTypes = {
    requery: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { requery }
)(withRouter(PastContest));
